import type { FaireProductEntity } from "../../entity_types/product";

export const p_c84vx3t9tt: FaireProductEntity = {
  token: "p_c84vx3t9tt",
  type: "product",
  name: "Trinket Box, Dresser",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/78be9b64c413b938fe3536f62d663ddbf0ce4d836a0c0789220d30105e04c75f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/698e6e1739286bd589138077f6cb8d82663f222c8acdd2d89537f4b0a68cc885.jpeg",
    "https://cdn.faire.com/fastly/3fe41c4fbbe263dfdd46fcbe4e89f22696943029be5ad58321f75017235fc8db.jpeg",
    "https://cdn.faire.com/fastly/876cb9ce95278625db58777e0010d68b29ae1d3cc30b2ccd448ee0630b6326fb.jpeg",
    "https://cdn.faire.com/fastly/1a713b4a5f90e70b9b71a683128a134957fb675fd1179e5ad929163e6b5c2acc.jpeg",
    "https://cdn.faire.com/fastly/669ab2d17c24b457c5db3c9828c6778df3fa54230cabef717c7a7f48f0f76a9f.jpeg",
    "https://cdn.faire.com/fastly/c1167523708e127d2262c9426f73b5cc8d565ec0103801870b904bdd4848bfea.jpeg"
  ],
  priceDollars: 13,
  description: "Put your trinkets in this tiny dresser with this tiny little lamp on top. You’ll feel like a doll in the tiniest little doll house. Trust us, we’ve tried it. Highly recommend.  \n\nProduct Details: \nDimensions: 5.25 in. x 2 in. 4.5 in. \nCeramic\nRemovable lid\nRelief details\n3D lamp detail\n\nFeatures:\nMiniature dresser design with a tiny decorative lamp\nCompact storage for jewelry, trinkets, keepsakes, and small treasures\nDollhouse-inspired aesthetic with playful, whimsical appeal\nFun statement piece for vanities, desks, shelves, and nightstands\nSmall footprint makes it easy to merchandise and display\nUnique, giftable design that adds personality to any space\n\nIdeal For:\nGift shops and lifestyle boutiques\nHome décor and specialty retailers\nJewelry and accessory boutiques\nBookstores and novelty gift shops\nStores specializing in playful, colorful, or whimsical products\nBirthday, holiday, stocking-stuffer, and just-because gifting\nRetailers looking for unique impulse-friendly accessories and décor",
  tags: [],
  msrpDollars: 26.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:16.994Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
